module.exports = __webpack_public_path__ + "img/planner-explicae.b819058a.svg";